import BasePage from "./BasePage";

const HomePage = (props) => {
  return <BasePage isLightBlue={true} isLoggedIn={true}></BasePage>;
};

export default HomePage;
